'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { getLoggedUserData } from '@/components/@analitycs/get-logged-user-data'

type DataGtm = {
  eventName:
    | 'material_view'
    | 'add_to_cart'
    | 'Purchase'
    | 'assessment_view'
    | 'task_failed'
    | 'task_passed'
    | 'orderPlaced'
    | 'lead_social'
    | 'add_payment_info'
    | 'login'
    | 'sign_up'
    | 'begin_checkout'
    | 'qualify_lead'
    | 'select_item'
    | 'view_item'
    | 'subscription'
    | 'search'
    | 'ViewContent'
  [key: string]: any
}

export function useGTM() {
  const handleSendGTMEvent = async (data: DataGtm) => {
    const userData = await getLoggedUserData()

    sendGTMEvent({
      event: 'vitrine',
      environment: 'Vitrine',
      ...(userData && { user_data: userData }),
      ...data,
    })
  }

  return { handleSendGTMEvent }
}
